import { Component, OnInit, TemplateRef } from '@angular/core';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DatePipe } from '@angular/common';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ExportExcel } from 'src/app/viewmodels/ExportExcel';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { E_G_EPSStatusType } from 'src/app/viewmodels/g-purchase/E_G_EPSStatusType';
import { AppConsts } from 'src/app/common/app-consts';

@Component({
  selector: 'app-sale-completed',
  templateUrl: './sale-completed.component.html',
  styleUrls: ['./sale-completed.component.scss']
})
export class SaleCompletedComponent implements OnInit {
  myDate = new Date(Date.now());
  public component_Title = 'WIP Repair Orders';
  public itemVm: GVechileViewModel = new GVechileViewModel();
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmListItems: any = [];
  public attachmentList: any = [];
  public vmCompList: any = [];
  modalRef: BsModalRef;
  public customerDetail: any = null;
  public selectedcustomerDetail: any = null;
  public exportFormat: string = 'csv';
  startDate: any = null;
  endDate: any = null;
  public CustomerDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',  // The field to use for the selected ID
    textField: 'name',  // The field to use for displaying the customer name
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };
  public client: any;

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  isListVisible: boolean = false;
  constructor(
    private datePipe: DatePipe,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnInit() {

    this.client = this._localStorageService.get("com");
    this.getList();
    // this.client = this._localStorageService.get("com");
    // this.spinner.show();
    // this._uow.saleService.GetPagedResultByCompleted().subscribe((res: any) => {
    //   this.vmCompList = res.DtlList;
    //   this.vm = res.DtlList;

    //   console.log(this.vm);
    //   this.spinner.hide();
    //   // this._jq.showSpinner();
    // }, (err) => {
    //   console.log(err);
    //   this.spinner.hide();
    //   Swal.fire(
    //     'Failure!',
    //     'Network Issue!',
    //     'error'
    //   )
    //   // this._jq.showSpinner();
    // });
  }


  // Method to toggle the visibility of the list
  toggleList() {
    this.isListVisible = !this.isListVisible;
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSaleService.getListById("GSale", "GetGSalesAsync", this.p, this.size, search, this.orderBy, this.sort, E_G_EPSStatusType.SaleCompleted)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vm = res.result;
          this.vmCompList = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
    this.isListVisible = false;
  }

  public clearOrder() {
    this.orderBy = 'Id';
    this.sort = 'Desc';
    this.getList();
    this.isListVisible = false;
  }

  // onButtonClick() {
  //   debugger
  //   this._jq.showSpinner(true);
  //   this._router.navigate(['/repair-invoice', {Id: this.vm.Id}]);
  // }

  openAttachmentModal(template: TemplateRef<any>, b) {
    debugger
    this._uow.gSaleService.GetGSaleByIdAsync(b).subscribe((res: any) => {
      this.attachmentList = res.attachmentList;
      console.log(this.attachmentList);
    });
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }


  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.vm = new SaveSaleMasterRequest();
      this.getList();
    } else {
      this._jq.showSpinner();
    }
  }

  public deleteId: string;
  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
      this.deleteId = model.uniqueId;
    }
  }

  confirmDelete() {
    this.spinner.show();
    this._uow.gSaleService.DeleteGSaleAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
      this.spinner.hide();
    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.vm = model;
    } else {
      this.vm = new SaveSaleMasterRequest();
    }
  }
  openExportModel(template: TemplateRef<any>) {
    this.openModal(template);
    this.getCustomerName();
  }


  getCustomerName() {
    debugger;
    this._uow.gSettingService.GetGCustomersDropDownAsync(AppConsts.CUSTOMER).subscribe(
      (res: any) => {
        debugger;
        this.customerDetail = res.result.map(x => {
          return {
            id: x.id, // or the actual ID field
            accTitle: x.accCode + '-' + x.accTitle // concatenated name and code
          };
        });

        // this.itemVm.RegistraionNumber = res;
        console.log(res);
        this._jq.showSpinner();
        // this.itemVm.RegistraionNumber = res.code;
      },
      (error) => {
        this._uow.logger.log(error);
        this._jq.showSpinner();
      }
    );
  }

  exportToExcel() {
    debugger;
    this.spinner.show();
    // var obj = new ExportExcel();
    // obj = {

    //   StartDate: this.startDate,
    //   EndDate: this.endDate,
    //   Format: this.exportFormat
    // }
    var CustomerId = this.selectedcustomerDetail && this.selectedcustomerDetail.length > 0
      ? this.selectedcustomerDetail[0].id
      : 0;

    this._uow.gSaleService.GetAllSaleOrdersExportAsync(CustomerId, this.startDate, this.endDate, 9).subscribe((res: any) => {
      debugger;
      this.openLinkInNewTab(res.file);
      this.spinner.hide();
      this.modalRef.hide();
    },
      (error) => {
        this._uow.logger.log(error);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
      });
  }

  openLinkInNewTab(url) {
    window.open(url, '_blank');
  }

  //   exportToExcel(){
  // debugger;
  // this.spinner.show();
  //     var obj = new ExportExcel();
  //     obj={
  //       Customer_Id: this.selectedcustomerDetail && this.selectedcustomerDetail.length > 0 
  //       ? this.selectedcustomerDetail[0].id 
  //       : null,  // Assign null if selectedcustomerDetail is null or empty
  //       StartDate: this.startDate,
  //       EndDate: this.endDate,
  //       Format: this.exportFormat
  //     }
  // this._uow.saleService.ExportSaleCompleted(obj).subscribe((res:any)=>{
  // debugger;

  // const blob = new Blob([res], { type: res.type });
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = `CompletedSalesData_${new Date().toISOString().split('T')[0]}.${this.exportFormat.toLowerCase()}`;
  //         document.body.appendChild(a);
  //         a.click();
  //         window.URL.revokeObjectURL(url);
  //         document.body.removeChild(a);

  //         this.spinner.hide();
  //         this.modalRef.hide();
  // },
  // (error)=>{
  //   this._uow.logger.log(error);
  //   this.spinner.hide();
  //   Swal.fire(
  //     'Failure!',
  //     'Network Issue!',
  //     'error'
  //   )
  // });
  //   }
}
